import { render, staticRenderFns } from "./videoG.vue?vue&type=template&id=a01a5ec8&"
import script from "./videoG.vue?vue&type=script&lang=js&"
export * from "./videoG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports